import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private backStack: string[] = [];
    private forwardStack: string[] = [];

    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const currentUrl = event.urlAfterRedirects;

                if (this.backStack.length === 0 || this.backStack[this.backStack.length - 1] !== currentUrl) {
                    this.backStack.push(currentUrl);
                    this.forwardStack = [];
                }
            }
        });
    }

    public handleBrowserBack(): void {
        if (this.backStack.length > 1) {
            const currentUrl = this.backStack.pop();
            if (currentUrl) {
                this.forwardStack.push(currentUrl);
            }
        }
    }
}